import {
  FilterOption,
  V53FlavorOption,
  ProductOption,
  SortOption,
  V53AGZFlavorOption,
  ProductOptionValue,
  V53AGZFlavorOptionValue,
  V53FlavorOptionValue,
  ProductOptionSkuKey,
  RatingOption,
  RatingCount
} from '@portal/types/review';
import {
  REVIEW_PRODUCT_FLAVOR_OPTION_VALUE_TO_SKU_MAP,
  REVIEW_PRODUCT_FLAVOR_OPTION_VALUE_TO_SKU_MAP_AGZ,
  REVIEW_PRODUCT_OPTION_VALUE_TO_SKU_MAP
} from '@portal/shared/constants/review';

export const WRITTEN_REVIEW_PAGINATION_LIMIT = 25;

export const SORT_BY_OPTION_LIST: SortOption[] = [
  {
    id: 'sort__newest',
    value: 'newest',
    label: 'Newest - oldest'
  },
  {
    id: 'sort__oldest',
    value: 'oldest',
    label: 'Oldest - newest'
  }
];

export const FILTER_BY_OPTION_LIST: FilterOption[] = [
  {
    id: 'filter__all',
    value: 'all',
    label: 'View All'
  },
  {
    id: 'filter__ag-1-next-gen',
    value: 'ag1-next-gen',
    label: 'AG1 Next Gen'
  },
  {
    id: 'filter__ag1',
    value: 'ag1',
    label: 'AG1'
  },
  {
    id: 'filter__ag-agz',
    value: 'ag-agz',
    label: 'AGZ'
  },
  {
    id: 'filter__ag-vitamin-d3-k2',
    value: 'ag-vitamin-d3-k2',
    label: 'AG Vitamin D3+K2'
  },
  {
    id: 'filter__ag-omega3',
    value: 'ag-omega3',
    label: 'AG Omega3'
  }
];

export const REVIEW_PRODUCT_OPTION_LIST: ProductOption[] = [
  {
    id: 'product__ag-1-next-gen',
    label: 'AG1 Next Gen',
    value: 'ag1-next-gen'
  },
  {
    id: 'product__ag1',
    label: 'AG1',
    value: 'ag1'
  },
  {
    id: 'product__ag-agz',
    label: 'AGZ',
    value: 'ag-agz'
  },
  {
    id: 'product__ag1-vitamin-d3-k2',
    label: 'AG Vitamin D3+K2',
    value: 'ag-vitamin-d3-k2'
  },
  {
    id: 'product__ag-omega3',
    label: 'AG Omega3',
    value: 'ag-omega3'
  }
];

export const REVIEW_PRODUCT_FLAVOR_OPTION_LIST: V53FlavorOption[] = [
  {
    id: 'flavor__flavor__all',
    label: 'See All',
    value: 'all'
  },
  {
    id: 'flavor__original',
    label: 'Original',
    value: 'original'
  },
  {
    id: 'flavor__tropical',
    label: 'Tropical',
    value: 'tropical'
  },
  {
    id: 'flavor__citrus',
    label: 'Citrus',
    value: 'citrus'
  },
  {
    id: 'flavor__berry',
    label: 'Berry',
    value: 'berry'
  }
];

export const REVIEW_PRODUCT_FLAVOR_OPTION_LIST_AGZ: V53AGZFlavorOption[] = [
  {
    id: 'flavor__flavor__all',
    label: 'See All',
    value: 'all'
  },
  {
    id: 'flavor__chocolate',
    label: 'Chocolate',
    value: 'chocolate'
  },
  {
    id: 'flavor__chocolate-mint',
    label: 'Chocolate Mint',
    value: 'chocolate-mint'
  },
  {
    id: 'flavor__mixed-berry',
    label: 'Mixed Berry',
    value: 'mixed-berry'
  }
];

export const RATING_OPTION_LIST: RatingOption[] = [
  {
    id: 'rating__all',
    value: 'all',
    label: 'All',
    count: 0
  },
  {
    id: 'rating__5',
    value: 5,
    count: 0
  },
  {
    id: 'rating__4',
    value: 4,
    count: 0
  },
  {
    id: 'rating__3',
    value: 3,
    count: 0
  },
  {
    id: 'rating__2',
    value: 2,
    count: 0
  },
  {
    id: 'rating__1',
    value: 1,
    count: 0
  }
];

export const MOBILE_REVIEW_CONTENT_CHAR_LIMIT = 250;

export const DESKTOP_REVIEW_CONTENT_CHAR_LIMIT = 350;

export const SKU_TO_PRODUCT_FLAVOR_MAP = (
  productType: ProductOptionValue,
  productFlavor: V53FlavorOptionValue | V53AGZFlavorOptionValue
) => {
  if (productType === 'ag1-next-gen' && productFlavor) {
    return REVIEW_PRODUCT_FLAVOR_OPTION_VALUE_TO_SKU_MAP[productFlavor as V53FlavorOptionValue];
  }
  if (productType === 'ag-agz' && productFlavor) {
    return REVIEW_PRODUCT_FLAVOR_OPTION_VALUE_TO_SKU_MAP_AGZ[
      productFlavor as V53AGZFlavorOptionValue
    ];
  }
  return REVIEW_PRODUCT_OPTION_VALUE_TO_SKU_MAP[productType as ProductOptionSkuKey];
};

export const getUpdatedRatingOptions = (ratingCounts: RatingCount[]) => {
  return RATING_OPTION_LIST.map((option) => {
    if (option.value === 'all') {
      const total = ratingCounts.reduce((sum, item) => sum + item.count, 0);
      return { ...option, count: total };
    }

    const ratingCount = ratingCounts.find((r) => r.rating === option.value);
    return {
      ...option,
      count: ratingCount ? ratingCount.count : 0
    };
  });
};
